import { useUser } from "@/auth/useUser";
import { useFeatureManagementFlagsQuery } from "@/graphql/queries/featureManagementFlags.graphql.types";
import {
  FeatureManagementFlags,
  FeatureManagementFlag,
} from "@/utils/featureManagementFlags";

export default function useFeatureManagement() {
  const { medspa } = useUser();

  const { data, loading } = useFeatureManagementFlagsQuery({
    variables: {
      medspaId: medspa,
    },
    skip: !medspa,
  });

  const featureManagementFlags = data?.featureManagementFlags || [];

  /**
   * Check if a feature is enabled based on feature management settings
   * @param codename - The feature management codename
   * @returns boolean - True if feature is enabled or undefined/null
   */
  const isFeatureEnabled = (codename: FeatureManagementFlag): boolean => {
    const feature = featureManagementFlags.find(
      (flag) => flag?.codename === codename
    );

    return feature?.enabled ?? false;
  };

  return {
    // Raw data
    featureManagementFlags,

    // Loading state
    featureManagementLoading: loading,

    // Utility functions
    isFeatureEnabled,

    // Specific feature checks based on featureManagementFlags.tsx registry
    // These return the feature management state only (not combined with feature flags)
    checkInAlertsEnabled: isFeatureEnabled(
      FeatureManagementFlags.CHECK_IN_ALERTS
    ),
    salesAttributionEnabled: isFeatureEnabled(
      FeatureManagementFlags.SALES_ATTRIBUTION
    ),
    waitlistEnabled: isFeatureEnabled(FeatureManagementFlags.WAITLIST),
    moxieAiBookingAssistantEnabled: isFeatureEnabled(
      FeatureManagementFlags.MOXIE_AI_BOOKING_ASSISTANT
    ),
    depositsEnabled: isFeatureEnabled(FeatureManagementFlags.DEPOSITS),
    clockInOutEnabled: isFeatureEnabled(FeatureManagementFlags.CLOCK_IN_OUT),
  };
}
